export { default } from './get-custom-appearance';
